import React from "react";
import { Typography, ListItem, ListItemAvatar, Avatar, ListItemText, Box } from "@mui/material";
import { Constants } from "../../constants";

const BalanceCom = ({ img, name, coin }) => {
    return (
        <ListItem sx={{ width: "100%", display: "flex", alignItems: "center" }}>
            <ListItemAvatar>
                <Avatar src={img} sx={{ width: "50px", height: "50px" }} />
            </ListItemAvatar>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: { sm: "center", xs: "start" }, flex: 1, ml: { sm: 3, xs: 2 }, flexDirection: { sm: "row", xs: "column" } }}>
                <ListItemText
                    primary={
                        <Typography variant="h5">
                            {name}
                        </Typography>
                    }
                    secondary={
                        <Typography variant="h6" color="secondary.light" fontWeight={500}>
                            account number . : 123456789786
                        </Typography>

                    }
                />

                <Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}><img src={Constants.customImages.Stack} alt="coine" width={"25px"} />
                    <Typography variant="h5" fontWeight={500} color="blue.main">{coin}</Typography>
                    </ Box>
                    <Typography variant="h6" color="secondary.light" textAlign={"center"}> 12:34 am</Typography>
                </Box>

            </Box>
        </ListItem>


    )
}

export default BalanceCom